import {Fragment, useState} from "react";
import {Box} from "@mui/system";
import {useDispatch, useSelector} from "react-redux";
import {customFieldActions} from "_actions";
import useModalSetup from "../../../../../hooks/useModalSetup";
import AddCustomFieldModal from "./AddCustomFieldModal";
import IconAdd from "../../../../../common/IconAdd";
import TextButton from "../../../../../common/TextButton";
import CircularProgress from "@mui/material/CircularProgress";

export default function AddCustomFieldEntry({msgDataSourceId}) {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();
    const dispatch = useDispatch();
    const [prevDataSourceId, setPrevDataSourceId] = useState(null);
    const loading = useSelector(state => state.customField.createCustomFieldsLoading);
    const selectedMsgDataSource = useSelector(state => state.customField.selectedMsgDataSource);
    const isSelected = selectedMsgDataSource?.id === msgDataSourceId;

    const handleOpen = () => {
        if (msgDataSourceId && msgDataSourceId !== prevDataSourceId) {
            dispatch(customFieldActions.fetchCustomFields(msgDataSourceId));
            setPrevDataSourceId(msgDataSourceId);
        }
        handleOpenModal();
    };

    return (
        <Fragment>
            <Box sx={{display: 'flex'}}>
                { loading && isSelected && <CircularProgress size={15} sx={style.loading}/> }
                <TextButton
                    label={'Add new'}
                    action={handleOpen}
                    startIcon={<IconAdd style={{ color: loading ? '#9EC5C2' : undefined }} />}
                    sx={style.actionButton}
                    disabled={loading}
                />
            </Box>

            <AddCustomFieldModal
                title={'Custom field settings'}
                msgDataSourceId={msgDataSourceId}
                open={openModal}
                handleClose={handleCloseModal}
            />
        </Fragment>
    );
}

const style = {
    actionButton: {
        mt: '-7px',
        height: '25px'
    },
    loading: {
        color: '#003300',
        mr: '15px'
    }
};
